import React from 'react';
import { parseTokens } from './tokenUtils';

// BL-080 — renders authored text with merge tokens shown as inline chips
// (never raw {{text}}), per the mockup.
function TokenChips({ text }) {
  const segments = parseTokens(text);
  return (
    <>
      {segments.map((seg, i) => (
        seg.type === 'token'
          // eslint-disable-next-line react/no-array-index-key
          ? <span className="un-tok" key={i}>{`{{${seg.key}}}`}</span>
          // eslint-disable-next-line react/no-array-index-key
          : <React.Fragment key={i}>{seg.value}</React.Fragment>
      ))}
    </>
  );
}

export default TokenChips;
